import TokenService from "./tokenService.js";
import storage from '../store/modules/storage.js';
import SocketDefaultService from "./socketDefaultService.js";
import axios from 'axios';
import store from '../store/index.js';

class AuthService {

    constructor() {
        this.refreshTimeoutId = null;
        this.refreshPromise = null; 
    }

    login(dadosLogin) {
        return axios.post("/auth/login", {
            ...dadosLogin,
            obterDados: true
        })
        .then((response) => {
            if (response.data.accessToken) {
                const keysToGet = ["frontend", "usuariosHistorico"]
                const currentProps = storage.getLocalData(keysToGet);
                
                const dados = {...response.data, ...currentProps}
            
                TokenService.setUser(dados);
                console.log("Iniciando Refresh Proativo")
                this.startRefreshTokenTimer(dados.validityAccess);

                delete dados.frontend;
                delete dados.accessToken;
                delete dados.refreshToken;
                SocketDefaultService.userConnect(dados);
            }
            return response.data;
        });
    }

    logout() {
        if (this.refreshTimeoutId) {
            clearTimeout(this.refreshTimeoutId);
        }

        const keysToKeep = ["usuariosHistorico"]; 
        const userObject = TokenService.getUser();
        
        const filteredUser = keysToKeep.reduce((acc, key) => {
          if (userObject.hasOwnProperty(key)) {
            acc[key] = userObject[key];
          }
          return acc;
        }, {}); 
        
        TokenService.setUser(filteredUser); 
        axios.defaults.headers.common['Authorization'] = "";

    }

    register({ username, email, password }) {
        // TODO ?
    }


    async refreshToken() {
        if (this.refreshPromise) {
            return this.refreshPromise;
        }

        this.refreshPromise = new Promise(async (resolve, reject) => {
            try {
                const result = await navigator.locks.request('refresh_mutex', async () => {
                    const storedUser = TokenService.getUser(); 
                    const now = Date.now();
                    const storedExpiration = storedUser?.validityAccess ? new Date(storedUser.validityAccess).getTime() : 0;
                    const isTokenValidInFuture = storedExpiration > (now + 30000);

                    if (storedUser?.accessToken && isTokenValidInFuture) {   
                        await this.updateLocalState(storedUser.accessToken, storedUser.validityAccess);
                        return storedUser.accessToken; 
                    }

                    const refreshToken = storedUser?.refreshToken;
            
                    if (!refreshToken) throw new Error("Sem refresh token disponível");

                    let subdominio = '';
                    if (typeof window !== 'undefined') {
                        const hostParts = window.location.host.split('.');
                        if (hostParts.length > 0) subdominio = hostParts[0];
                    }

                    const response = await axios.post("/auth/refresh", {
                        refreshToken, 
                        subdominio
                    });
                    TokenService.updateLocalAccessTokenAllProperties(response.data);
                    await this.updateLocalState(response.data.accessToken, response.data.validityAccess);

                    return response.data.accessToken;
                });

                resolve(result);

            } catch (error) {
                console.error("[AuthService] - Falha no refresh proativo:", error);
                this.logout();
                reject(error);
            } finally {
                this.refreshPromise = null;
            }
        });

        return this.refreshPromise;
    }

    async updateLocalState(accessToken, validityAccess) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        store.dispatch('auth/refreshToken', accessToken);
        this.startRefreshTokenTimer(validityAccess);
    }

    startRefreshTokenTimer(expirationValue) {
        if (!expirationValue) return;

        const now = Date.now();
        const expirationTime = new Date(expirationValue).getTime()
        const delay = (expirationTime - now) - 15000 ;
        if (this.refreshTimeoutId) clearTimeout(this.refreshTimeoutId);

        if (delay > 0) {
            this.refreshTimeoutId = setTimeout(() => {
                this.refreshToken().catch(err => console.error("Erro no silent refresh", err));
            }, delay);
        }else{
            this.refreshToken().catch(err => console.error("Erro no silent refresh", err));
        }
    }
}

export default new AuthService();